/*
 *   File : push-notification.js
 *   Author : https://evoqins.com
 *   Description : Create push notification modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React from 'react';

// custom components
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { Icon } from '../Icon';
import { Chip } from '../Others';

// custom style
import style from "../../Style/Component/modal.module.scss";

const ViewDetailModal = (props) => {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("view-detail-modal-close");
        button.click();
        props.handleClose();
    };

    return (
        <div className="modal fade "
            id="proof-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="ViewDetailModalLabel"
            aria-hidden="true">

            <div className={` modal-dialog modal-dialog-centered ${props.type === 2 ? 'modal-lg' : style.e_push_notification_modal_width} modal-dialog-scrollable border-radius-28`}>
                <span id='view-detail-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className={` modal-content border-radius-28  border-0`}>
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top  padding-24px-bottom">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            View Bank details
                        </h6>

                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className={`padding-32px-bottom  modal-body px-0 pt-0`}>

                        <>
                            <div className='padding-32px-lr'>
                                <div className=' py-3  e-bg-magnolia border-radius-16 e-border-1px-pale-lavender-extra-light '>
                                    {/* details */}
                                    <div className='px-3 d-flex align-items-center pb-3 gap-4 justify-content-between e-border-bottom-2px-platinum-light'>
                                        <div>
                                            <div className='e-font-weight-400 pb-2 e-font-14 line-height-16px e-text-dark-silver'>Account type</div>
                                            <div className='e-font-weight-600 e-font-14 line-height-16px e-text-dim-black'>{props.data.account_type || "-"}</div>
                                        </div>
                                        <div >
                                            <div className='e-font-weight-400 pb-2 e-font-14 line-height-16px e-text-dark-silver'>Bank name</div>
                                            <div className='e-font-weight-600 e-font-14 line-height-16px e-text-dim-black'>{props.data.bank_name || "-"}</div>
                                        </div>
                                        <div >
                                            <div className='e-font-weight-400 pb-2 e-font-14 line-height-16px e-text-dark-silver'>IFSC code</div>
                                            <div className='e-font-weight-600 e-font-14 line-height-16px e-text-dim-black'>{props.data.ifsc || "-"}</div>
                                        </div>
                                    </div>

                                    {/* account details */}
                                    <div className='px-3 d-flex align-items-start py-3 gap-4 e-border-bottom-2px-platinum-light'>
                                        <div>
                                            <div className='e-font-weight-400 pb-2 mb-1 e-font-14 line-height-16px e-text-dark-silver'>Account number</div>
                                            <div className='e-font-weight-600 e-font-14 line-height-16px e-text-dim-black'>{props.data.account_number || "-"}</div>
                                        </div>
                                        <div className=''>
                                            <div className='e-font-weight-400 pb-2 e-font-14 line-height-16px e-text-dark-silver'>KYC verification status</div>
                                            <Chip label={props.data.kyc_verification_status}
                                                textAlign='justify-content-start'
                                                className={props.data.kyc_verification_status.toLowerCase() === "verified" ? "e-bg-light-green e-text-dark-gray " : "e-text-dark-gray e-bg-pale-pink"} />
                                        </div>
                                    </div>

                                    {/* proof document */}
                                    <div className='px-3 pt-3'>
                                        <div className='e-font-weight-400 pb-2 e-font-14 line-height-16px e-text-dark-silver '>Bank proof</div>
                                        {/* {props.data.bank_proof ?
                                            <img src={props.data.bank_proof}
                                                alt="proof document"
                                                // width={411} 
                                                height={184}
                                                className={`${style.e_bank_proof_img} w-100`} />
                                            :
                                            "-"
                                        } */}
                                        {props.data.bank_proof ? (() => {
                                            const fileUrl = props.data.bank_proof;

                                            const extension = fileUrl
                                                .split('?')[0]
                                                .split('.')
                                                .pop()
                                                .toLowerCase();

                                            const isPdf = extension === 'pdf';

                                            if (isPdf) {
                                                return (
                                                    <div className={style.e_bank_proof_pdf}>
                                                        <a
                                                            href={fileUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="e-text-blue-violet e-font-weight-600 e-font-14 line-height-16px text-decoration-none text-decoration-hover-underline"
                                                        >
                                                            📄 View Proof
                                                        </a>
                                                    </div>
                                                );
                                            }

                                            return (
                                                <img
                                                    src={fileUrl}
                                                    alt="proof document"
                                                    height={184}
                                                    className={`${style.e_bank_proof_img} w-100`}
                                                />
                                            );
                                        })() : "-"}
                                    </div>
                                </div>
                            </div>
                        </>

                    </div>

                    {/* Modal footer  */}
                    {props.button === true &&
                        <div className={`padding-32px-all modal-footer border-0 gap-3`}>
                            <>
                                <SecondaryButton name="Cancel"
                                    paddingBlock='padding-12px-tb padding-52px-lr'
                                    onClick={_handleCloseModal} />
                                <PrimaryButton name="Send"
                                    paddingBlock='padding-12px-tb padding-52px-lr' />
                            </>
                        </div>
                    }
                </div>
            </div>
        </div >
    )
}

export default ViewDetailModal;

ViewDetailModal.defaultProps = {
    handleClose: () => { },
    type: 1,
}